import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "loading-layout",
  class: "min-h-full p-6 d-flex w-full align-items-center"
}
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { id: "main" }
const _hoisted_5 = { id: "content" }
const _hoisted_6 = { class: "d-flex flex-column mt-6" }
const _hoisted_7 = { class: "position-absolute bottom-0 d-flex justify-content-center w-full text-xs align-items-center py-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "|", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoComponent = _resolveComponent("LogoComponent")!
  const _component_LoaderSpinnerComponent = _resolveComponent("LoaderSpinnerComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_LogoComponent)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_LoaderSpinnerComponent)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_7, [
      _createElementVNode("span", null, "© " + _toDisplayString(new Date().getFullYear()) + " " + _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$config('AppConfig', 'Name'))), 1),
      _hoisted_8,
      _createVNode(_component_router_link, {
        class: "text-body text-underline",
        to: { name: _ctx.$config('RouteConfig', 'PrivacyPolicyRouteName') }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$beautify.firstLetterUppercase(
					_ctx.$text('routes_name', 'Route_Privacy_Policy_Name')
				)), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ], 64))
}